/**
 * Calculate remaining user cash
 *
 * @param buyingPower
 * @param withdrawableBlockedMoney
 * @returns {number}
 */
function calcRemainingCash(
  buyingPower = 0,
  withdrawableBlockedMoney = 0
): number {
  return buyingPower + withdrawableBlockedMoney;
}

function calcLegacyOmsNetAsset({
  totalPortfolioValues,
  nonWithdrawableBlockedMoney,
  nonWithdrawableMoneyRemain,
  withdrawableBlockedMoney,
  withdrawableMoneyRemain,
}: {
  totalPortfolioValues: number;
  nonWithdrawableBlockedMoney: number;
  nonWithdrawableMoneyRemain: number;
  withdrawableBlockedMoney: number;
  withdrawableMoneyRemain: number;
}): number {
  return (
    totalPortfolioValues +
    nonWithdrawableBlockedMoney +
    nonWithdrawableMoneyRemain +
    withdrawableBlockedMoney +
    withdrawableMoneyRemain
  );
}

function calcNewOmsNetAsset({
  totalPortfolioValues,
  t2,
  usedCredit,
}: {
  totalPortfolioValues: number;
  t2: number;
  usedCredit: number;
}): number {
  return totalPortfolioValues + t2 - usedCredit;
}

type CalcTradableCredit = {
  creditMoney: number;
  usedCredit: number;
  creditBlockedMoney: number;
};

function calcTradableCredit({
  creditMoney,
  creditBlockedMoney,
  usedCredit,
}: CalcTradableCredit) {
  return creditMoney - usedCredit - creditBlockedMoney;
}

export {
  calcRemainingCash,
  calcLegacyOmsNetAsset,
  calcNewOmsNetAsset,
  calcTradableCredit,
};
